export default __webpack_public_path__ + "static/media/CRM.866c45ef.svg";